import Vue from 'vue';
import Store from '@app/store';
import Dropdown from '@app/components/Dropdown.vue';
export default Vue.extend({
    components: {
        Dropdown: Dropdown
    },
    computed: {
        languages: function () {
            return Store.STATE.languages;
        },
        activeLanguage: function () {
            return Store.GETTERS.activeLanguage();
        },
    },
});
